import {REST_METHODS} from '@/utils/api/types'

import {vpnAccessDisabledHttpStatusCode} from '../constants'

export class ServerError extends Error {
  extra: Record<string, any>
  status: number
  shouldCapture: boolean

  constructor(message: string, extra: Record<string, any>, status = 500, shouldCapture = true) {
    super(message)
    this.name = 'ServerError'
    this.extra = extra
    this.status = status
    this.shouldCapture = shouldCapture
  }
}

export class BadRequestError extends ServerError {
  constructor(message: string, extra: Record<string, any>, shouldCapture = true) {
    super(message, extra, 400, shouldCapture)
    this.name = 'BadRequestError'
  }
}

export class UnauthorizedError extends ServerError {
  constructor(shouldCapture = true) {
    super('Not Authenticated', {}, 401, shouldCapture)
    this.name = 'UnauthorizedError'
  }
}

export class ForbiddenError extends ServerError {
  constructor(message: string, extra: Record<string, any>, shouldCapture = true) {
    super(message, extra, 403, shouldCapture)
    this.name = 'ForbiddenError'
  }
}

export class NotFoundError extends ServerError {
  constructor(message: string, extra: Record<string, any>, shouldCapture = true) {
    super(message, extra, 404, shouldCapture)
    this.name = 'NotFoundError'
  }
}

export class MethodNotAllowedError extends ServerError {
  constructor(method: string, allowedMethods: REST_METHODS[], shouldCapture = false) {
    super(`Method ${method} not allowed`, {}, 405, shouldCapture)
    this.name = 'MethodNotAllowedError'
    this.extra = {allowedMethods}
  }
}

export class VpnForbiddenError extends ServerError {
  constructor(message: string, extra: Record<string, any>, shouldCapture = true) {
    super(message, extra, vpnAccessDisabledHttpStatusCode, shouldCapture)
    this.name = 'VpnForbiddenError'
  }
}
